(function () {
  var gsapDepsPromise = null;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function ensureGsapDeps() {
    if (typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined') {
      return Promise.resolve();
    }

    if (gsapDepsPromise) return gsapDepsPromise;

    var GSAP_URL = window.MBC_GSAP_URL || 'https://cdn.jsdelivr.net/npm/gsap@3.12.7/dist/gsap.min.js';
    var ST_URL = window.MBC_ST_URL || 'https://cdn.jsdelivr.net/npm/gsap@3.12.7/dist/ScrollTrigger.min.js';

    gsapDepsPromise = Promise.resolve()
      .then(function () {
        if (typeof window.gsap === 'undefined') return loadScript(GSAP_URL);
      })
      .then(function () {
        if (typeof window.ScrollTrigger === 'undefined') return loadScript(ST_URL);
      });

    return gsapDepsPromise;
  }

  window.ensureGsapDeps = ensureGsapDeps;

  function bindFeaturedIngredientsAccordions(root) {
    root.addEventListener(
      'toggle',
      function (event) {
        var item = event.target;
        if (!item.matches || !item.matches('.pdp-fi__item, .pdp-fi__accordion-item')) return;
        if (!item.open) return;

        var group = item.getAttribute('data-fi-group');
        if (!group) return;

        root.querySelectorAll('[data-fi-group="' + group + '"][open]').forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });

        var desktopItems = root.querySelectorAll('.pdp-fi__item');
        if (desktopItems.length) {
          desktopItems.forEach(function (desktopItem) {
            desktopItem.classList.toggle('is-active', desktopItem === item);
          });
        }
      },
      true
    );
  }

  function initFeaturedIngredients(root) {
    if (root.dataset.pdpReady === 'true') return;
    root.dataset.pdpReady = 'true';

    bindFeaturedIngredientsAccordions(root);

    var video = root.querySelector('[data-scrub-video]');
    if (video) {
      ensureGsapDeps()
        .then(function () {
          var gsap = window.gsap;
          var ScrollTrigger = window.ScrollTrigger;
          if (!gsap || !ScrollTrigger) return;

          if (root._pdpFiGsapCtx) root._pdpFiGsapCtx.revert();

          root._pdpFiGsapCtx = gsap.context(function () {
            if (video.readyState >= 1) {
              setupVideoScrub(video);
            } else {
              video.addEventListener('loadedmetadata', function () {
                setupVideoScrub(video);
              });
            }

            function setupVideoScrub(vid) {
              // Ensure duration is valid and not Infinity
              if (!vid.duration || !isFinite(vid.duration)) return;
              
              gsap.to(vid, {
                currentTime: vid.duration || 1,
                ease: 'none',
                scrollTrigger: {
                  trigger: root,
                  start: 'top bottom',
                  end: 'bottom top',
                  scrub: true
                }
              });
            }
          }, root);
        })
        .catch(function () {});
    }
  }

  function initFaqs(root) {
    if (root.dataset.pdpReady === 'true') return;
    root.dataset.pdpReady = 'true';

    var cta = root.querySelector('.pdp-faqs__cta');
    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof GorgiasChat !== 'undefined' && GorgiasChat.open) {
          GorgiasChat.open();
        } else {
          window.addEventListener('gorgias-widget-loaded', function() {
            if (typeof GorgiasChat !== 'undefined' && GorgiasChat.open) {
              GorgiasChat.open();
            }
          });
        }
      });
    }
  }

  function initPlaceholder(root) {
    if (root.dataset.pdpReady === 'true') return;
    root.dataset.pdpReady = 'true';
  }

  function initBenefits(root) {
    if (root.dataset.pdpReady === 'true') return;
    root.dataset.pdpReady = 'true';

    var wraps = root.querySelectorAll('.pdp-benefits__image-wrap');
    if (!wraps.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    ensureGsapDeps()
      .then(function () {
        var gsap = window.gsap;
        if (!gsap) return;

        if (root._pdpBenefitsGsapCtx) root._pdpBenefitsGsapCtx.revert();

        root._pdpBenefitsGsapCtx = gsap.context(function () {
          wraps.forEach(function (wrap, i) {
            var img = wrap.querySelector('img.pdp-benefits__image');
            if (!img) return;

            gsap.set(img, {
              scale: 1.06,
              transformOrigin: '50% 50%',
              force3D: true
            });

            gsap.to(img, {
              x: i === 0 ? '2%' : '-2%',
              y: i === 0 ? '-1.25%' : '1.25%',
              rotation: i === 0 ? 0.35 : -0.35,
              scale: 1.11,
              duration: i === 0 ? 15 : 12,
              ease: 'sine.inOut',
              repeat: -1,
              yoyo: true
            });
          });
        }, root);
      })
      .catch(function () {});
  }

  var moduleInitializers = {
    benefits: initBenefits,
    'featured-ingredients': initFeaturedIngredients,
    faqs: initFaqs,
    placeholder: initPlaceholder
  };

  function initPdpModules(scope) {
    var context = scope || document;
    var nodes = context.querySelectorAll('[data-pdp-module]');

    nodes.forEach(function (node) {
      var moduleName = node.getAttribute('data-pdp-module');
      var initializer = moduleInitializers[moduleName];
      if (initializer) initializer(node);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPdpModules(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initPdpModules(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    target.querySelectorAll('.pdp-mod--benefits').forEach(function (section) {
      if (section._pdpBenefitsGsapCtx) {
        section._pdpBenefitsGsapCtx.revert();
        delete section._pdpBenefitsGsapCtx;
      }
      section.removeAttribute('data-pdp-ready');
    });
    target.querySelectorAll('.pdp-mod--featured-ingredients').forEach(function (section) {
      if (section._pdpFiGsapCtx) {
        section._pdpFiGsapCtx.revert();
        delete section._pdpFiGsapCtx;
      }
      section.removeAttribute('data-pdp-ready');
    });
  });
})();
